import request from '@/utils/request';

// .................................................................查询未读消息数量
export function unreadCount(data) {
  return request({
    url: '/ysa-afterSale-service/after_sale/msg/unreadCount',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}

// .................................................................分页查询消息列表
export function queryMsgPage(data) {
  return request({
    url: '/ysa-afterSale-service/after_sale/msg/queryMsgPage',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}

// .................................................................标记已读
export function readMessage(data) {
  return request({
    url: "/ysa-afterSale-service/after_sale/msg/read/".concat(data.id),
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}

// .................................................................批量标记已读
export function batchReadMessage(data) {
  return request({
    url: '/ysa-afterSale-service/after_sale/msg/readBatch',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}

// .................................................................删除
export function deleteMessage(data) {
  return request({
    url: "/ysa-afterSale-service/after_sale/msg/delete/".concat(data.id),
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}

// .................................................................批量删除
export function batchDeleteMessage(data) {
  return request({
    url: '/ysa-afterSale-service/after_sale/msg/deleteBatch',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}